module.exports = __webpack_public_path__ + "media/images/flags/16/Egypt-2efd0220400a7e30c40f18bb935fffb9.png";